import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { history } from 'Store';
import store, { toggleMobileRouteToDashboard } from '@carvana/purchase-store';
import { ThemeProvider } from '@carvana/theme';
import LockTimerWidget from './components/lock-timer-widget';
import CartWidget from './components/cart-widget';
import * as sc from './widget-bar.styles';
import { AnalyticsContext } from '@carvana/eventable-clickstream';

const WidgetBar: React.FC<{
  isMobile: boolean;
  isAvailable?: boolean;
  orderState?: string;
  navigationConfiguration?: {
    widgetBar: {
      showWidgetBar: boolean;
      showCart: boolean;
      showLockTimer: boolean;
    };
  };
  vehicle?: any;
}> = (props) => {
  const { isMobile, isAvailable, orderState, vehicle, navigationConfiguration, ...rest } = props;

  const { trackEvent } = useContext(AnalyticsContext);

  const showNavigationRail = () => {
    // TODO: add event for thing here
    trackEvent('pp_clicked_back_arrow');
    window.dispatchEvent(new Event('CurlyBackArrow'));
    store.dispatch(toggleMobileRouteToDashboard(true));
    history.push('/dashboard');
  };

  if (!navigationConfiguration?.widgetBar?.showWidgetBar) {
    return null;
  }

  return (
    <ThemeProvider>
      <sc.Wrapper>
        {isMobile && (
          <sc.WidgetWrapper hide={history.location.pathname === '/dashboard'}>
            <sc.ArrowBack onClick={showNavigationRail} />
          </sc.WidgetWrapper>
        )}
        <LockTimerWidget
          display={navigationConfiguration?.widgetBar?.showLockTimer}
          isMobile={isMobile}
          vehicleAvailable={isAvailable}
          orderState={orderState}
          {...rest}
        />
        <CartWidget
          display={navigationConfiguration?.widgetBar?.showCart}
          isMobile={isMobile}
          vehicleAvailable={isAvailable}
          vehicle={vehicle}
        />
      </sc.Wrapper>
    </ThemeProvider>
  );
};

WidgetBar.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isAvailable: PropTypes.bool,
  orderState: PropTypes.string,
  navigationConfiguration: PropTypes.shape({
    widgetBar: PropTypes.shape({
      showWidgetBar: PropTypes.bool.isRequired,
      showCart: PropTypes.bool.isRequired,
      showLockTimer: PropTypes.bool.isRequired,
    }).isRequired,
  }),
  vehicle: PropTypes.shape({}),
};

WidgetBar.defaultProps = {
  navigationConfiguration: {},
  orderState: null,
  isAvailable: true,
  vehicle: null,
};

export default WidgetBar;
